/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return*/

import { makeStyles } from "@material-ui/core"
import {
  PRIMARY_BACKGROUND,
  DEFAULT_BOX_SHADOW,
  TYPE_INSTANCE2,
  instance3,
} from "App/constants"
import {
  convertToValidPrice,
  defaultToastError,
  fetchData,
  getLocalName,
  isNull,
  today,
} from "App/utils/helpers"
import { isArray } from "lodash"
import moment from "moment"
import { useContext, useState, useEffect } from "react"
import { accessCode } from "utils/all"
import { FormContext } from "../context/FormContext"
import { useSelector } from "react-redux"
import React from "react"

// 3001
export const urlGetAsuransi = "/insurance/listinsurance"
export const urlGetJenisLayanan = "/jenis_layanan/listjenis_layanan"

// 3003
export const urlGetTipePembayaran = "/master/ms_tipe_pembayaran/list"
export const urlCreate = "/penjualan/register"
export const urlUpdate = "/penjualan/update"
export const urlClosePenjualan = "/penjualan/closePenjualan"

export const urlCreateExternal = "/penjualanExternal/registerExt"
export const urlUpdateExternal = "/penjualanExternal/update"

// 3004
export const urlGetKasBank = "/kas/kas/list-penjualan"
export const urlGetGudang = `/wmsfarmasi/gudang/list-penjualan?access_code=${accessCode.gudang_farmasi}`

/**
 * kalo aku berdasarkan db seng dibuat awan ya gini  //1. buka transaksi || 2. tutup transaksi || 3. kunci transaksi
 */

export const STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT = 0
export const STATUS_TRANSAKI_PENJUALAN_KUNCI = 1
export const STATUS_TRANSAKI_PENJUALAN_TUTUP = 2
export const STATUS_TRANSAKI_PENJUALAN_FRONT_OFFICE = 3

export const getExportPenjualanById = async (id) => {
  try {
    const api2 = await instance3.get(`/penjualan/export-rincian-pdf/${id}`, {
      responseType: "blob",
    })
    return {
      state: true,
      data: api2.data,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const getExportKwitansiById = async (id) => {
  try {
    const api2 = await instance3.get(
      `/penjualan/export-kwitansi-pdf?id=${id}&date=${moment()
        .local()
        .format("DD/MM/YYYY")}&petugas=${getLocalName()}`,
      {
        responseType: "blob",
      },
    )
    return {
      state: true,
      data: api2.data,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}

export const RESET_STATE_INPUT_PENJUALAN = {
  date: today(true),
  penjualan_id: "",
  is_jurnal: false,

  asuransi_id: null,
  asuransi: "Pilih Asuransi",
  noasuransi: "",

  petugas: getLocalName(),
  dokter_id: null,
  dokter_name: "Pilih DPJP",

  kelas_id: null,
  kelas_name: "Pilih Kelas",

  kunjungan_id: "",

  id_type_of_care: null,

  tipe_pembayaran_id: 1,
  tipe_pembayaran_name: "Pilih Tipe Pembayaran",

  jenis_layanan_id: null,
  jenis_layanan_name: "Pilih Jenis Layanan",

  kas_bank_id: null,
  kas_bank_name: "Pilih Kas Bank",

  gudang_id: null,
  gudang_name: "Pilih Gudang",

  is_lock: 0,
  tgl_lock: null,

  is_close: false,
  tgl_close: null,

  isUpdate: false,
  type: "create",

  rm_id: "-",
  jenisrm: 2,

  is_external: 1,

  // RM External
  nama: "",
  keterangan: "",

  /**
   * int ext digunakan untuk mencek apakah rm tersebut internal atau external
   * 1.jika internal
   * 2 jika external
   */

  intext: 2,

  fasilitas: [],
  jasa: [],
  rikjang: [],
  paket: [],
  barang: [],

  // Perhitungan

  jumlah: 0,
  potongan: 0,
  potongan2: 0,

  sub_total: 0,
  tax_percent: 0,
  tax_number: 0,

  total: 0,
  sisa: 0,
  pembayaran: 0,

  reload: false,
  reload_perhitungan: false,
  status_transaksi: STATUS_TRANSAKI_PENJUALAN_OPEN_DRAFT,
  // total_harga: 0,
  // final_total: 0,
  // End Perhitungan
}

export const reloadPerhitungan = (formData, setFormData) => {
  const reload = formData.reload_perhitungan || false
  setFormData({
    ...formData,
    reload_perhitungan: !reload,
  })
}

export const getTotalFilterID = async (arr, id, type) => {
  let total = 0
  await arr.map((e) => {
    if (e.id !== id) {
      // const { nilaiDiskon } = hitungDiskon(e, type)
      total += e.qty * (e.hargaCustom - e.nilai_diskon)
    }

    return true
  })

  return total
}

export const STYLE_PENJUALAN = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  inputButton: {
    height: "30px",
    width: "35px",
    background: "#EAEAEA",
    margin: "auto",
    cursor: "pointer",
    borderRadius: "4px",
    border: "1px solid #ddd8d8",
  },
  error: {
    color: "red",
    fontSize: "9px",
    marginTop: "2px",
    marginLeft: "2px",
    position: "absolute",
  },
  formControlLabel: {
    fontWeight: "400",
    color: "#BDBDBD",
    fontSize: "11px",
    minWidth: "40%",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "5px",
    borderBottom: "1.5px dashed #333333",
  },
  id: {
    paddingTop: "0.5rem",
    fontWeight: "600",
    fontSize: "16px",
    display: "flex",
    gap: "0.5rem",
  },
  parentId: {
    display: "flex",
    alignItems: "center",
    marginTop: "3px",
  },
})

export const validationFormPenjualan = (formData) => {
  if (isNull(formData.gudang_id)) {
    return {
      state: false,
      message: "Gudang tidak boleh kosong",
    }
  }

  if (isNull(formData.nama) || formData.nama === "-") {
    return {
      state: false,
      message: "Nama tidak boleh kosong",
    }
  }

  if (isNull(formData.kas_bank_id)) {
    return {
      state: false,
      message: "Kas Bank Tidak boleh kosong",
    }
  }

  if (isNull(formData.jenis_layanan_id)) {
    return {
      state: false,
      message: "Jenis Layanan Tidak boleh kosong",
    }
  }

  return {
    state: true,
    message: "valid",
  }
}

export function getTotal(arr, type) {
  let total = 0
  if (isArray(arr)) {
    arr.map((e) => {
      if (!isNull(e.hargaCustom) && !isNull(e.diskon)) {
        // const { nilaiDiskon } = hitungDiskon(e, type)

        total += (e.hargaCustom - e.nilai_diskon) * e.qty
      }
    })
  }
  return parseFloat(total)
}

export function validInputArray(arr) {
  const result = arr.map(({ id, ...rest }) => ({ ...rest }))
  return result
}

export function isExist(arr, key, value) {
  return arr.some(function (el) {
    return el[key] === value
  })
}

export const hitungDiskon = (data, type) => {
  try {
    if (type === "barang") {
      const hargaPokok = convertToValidPrice(data.hargapokok)
      const diskon = convertToValidPrice(data.diskon)
      const qty = convertToValidPrice(data.qty)
      const hargaCustom = convertToValidPrice(data.hargaCustom)

      const nilaiDiskon = (hargaCustom * diskon) / 100
      const totalHargaPokok = hargaPokok * qty
      const totalHargaJual = (hargaCustom - nilaiDiskon) * qty

      return {
        nilaiDiskon,
        totalHargaPokok,
        totalHargaJual,
      }
    } else if (type === "jasa") {
      const hargaBeli = convertToValidPrice(data.hargabeli)
      const diskon = convertToValidPrice(data.diskon)
      const qty = convertToValidPrice(data.qty)
      const hargaCustom = convertToValidPrice(data.hargaCustom)

      const nilaiDiskon = (hargaCustom * diskon) / 100
      const totalHargaPokok = hargaBeli * qty
      const totalHargaJual = (hargaCustom - nilaiDiskon) * qty

      return {
        nilaiDiskon,
        totalHargaPokok,
        totalHargaJual,
      }
    } else if (type === "fasilitas" || type === "rikjang") {
      const diskon = convertToValidPrice(data.diskon)
      const qty = convertToValidPrice(data.qty)
      const hargaCustom = convertToValidPrice(data.hargaCustom)

      const nilaiDiskon = (hargaCustom * diskon) / 100
      const totalHargaPokok = 0
      const totalHargaJual = (hargaCustom - nilaiDiskon) * qty

      return {
        nilaiDiskon,
        totalHargaPokok,
        totalHargaJual,
      }
    } else {
      return {
        nilaiDiskon: 0,
        totalHargaPokok: 0,
        totalHargaJual: 0,
      }
    }
  } catch (error) {
    return {
      nilaiDiskon: 0,
      totalHargaPokok: 0,
      totalHargaJual: 0,
    }
  }
}

/**
 * Helper pembulatan diselaraskan dengan BE HelperPenjualan.pembulatanHelper
 * @param {number} angka - Angka yang akan dibulatkan
 * @param {string|number} setting_data_1 - Setting untuk enable/disable pembulatan ("1" = dibulatkan, selain itu tidak)
 * @param {string|number} setting_data_2 - Setting untuk level pembulatan ("0" = bulat, "1" = puluhan, "2" = ratusan, "3" = ribuan)
 * @returns {number} - Angka yang sudah dibulatkan sesuai setting
 */
export const numberToFixed = (angka) => {
  return Number.parseFloat(Number(angka).toFixed(2))
}

export const pembulatanHelperFE = (angka, setting_data_1, setting_data_2) => {
  if (angka === null || angka === undefined) return angka
  if (typeof angka !== "number" || Number.isNaN(angka)) return angka
  if (angka < 0) return angka

  const s1 = String(setting_data_1 ?? "0")
  const s2 = String(setting_data_2 ?? "")

  if (s1 === "1") {
    if (s2 === "0") {
      angka = Math.ceil(angka)
    } else if (s2 === "1") {
      angka = Math.ceil(angka / 10) * 10
    } else if (s2 === "2") {
      angka = Math.ceil(angka / 100) * 100
    } else if (s2 === "3") {
      angka = Math.ceil(angka / 1000) * 1000
    } else {
      return numberToFixed(angka)
    }
    return numberToFixed(angka)
  }

  return numberToFixed(angka)
}

// Hook untuk mendapatkan fungsi pembulatan yang sudah terikat dengan setting redux
export const usePembulatanPenjualan = () => {
  const { setting_data_1, setting_data_2 } = useSelector(
    (s) => s.setting.float_penjualan,
  )
  const pembulatan = React.useCallback(
    (angka) => pembulatanHelperFE(angka, setting_data_1, setting_data_2),
    [setting_data_1, setting_data_2],
  )
  return pembulatan
}

export const useKelasDropdown = () => {
  const [data, setData] = useState([])
  const [defaultValue, setDefaultValue] = useState({
    value: "",
    label: "",
  })
  const { formData, setFormData } = useContext(FormContext)

  const setVal = async (res) => {
    const kelas = []
    await res.map((e) =>
      kelas.push({
        label: e.name,
        value: e.id,
      }),
    )

    setData(kelas)
    setFormData({
      ...formData,
      kelas_id: res[0]?.id,
    })

    setDefaultValue({
      label: res[0]?.name,
      value: res[0]?.id,
    })
  }

  useEffect(() => {
    ;(async () => {
      const res = await fetchData(
        TYPE_INSTANCE2,
        "/registration/kelaskunjungan/listkelaskunjungan",
      )
      if (res) {
        if (res.length === 0) {
          defaultToastError("Data kelas masih kosong!")
        }
        await setVal(res)
      }
    })()
  }, [])

  return {
    dataKelas: data,
    defaultValue,
  }
}
